/** @jsxRuntime classic */
/** @jsx jsx */
import { css } from '@emotion/core'

export const customTooltipWrapper = css`
    width: min-content;
    display: inline-block;
    margin-left: 0.5rem;
`
export const customTooltip = css`
    transform: translateX(-45%);
    width: 10rem;
`

export const customErrorTooltip = css`
  bottom: calc(100% - 10px);
`

export const customDialog = css`
  width: 40rem;
  max-width: 100%;
`
